import { render, staticRenderFns } from "./SofiaChatDemo.vue?vue&type=template&id=d7fd5ff6&scoped=true"
import script from "./SofiaChatDemo.vue?vue&type=script&lang=js"
export * from "./SofiaChatDemo.vue?vue&type=script&lang=js"
import style0 from "./SofiaChatDemo.vue?vue&type=style&index=0&id=d7fd5ff6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7fd5ff6",
  null
  
)

export default component.exports